<template>
  <div class="sf-inbox-detail-card">
    <template v-if="loadingCommunicationItem">
      <div class="sf-level sf-level-around sf-level-center sf-pad-5">
        <div class="sf-spinner" />
      </div>
    </template>

    <template v-else-if="communicationItem">
      <RemarkV2
        v-if="supportsCommunicationsRework && isRemarkType"
        :remark="communicationItem"
        show-context
        show-context-btn
        :show-tags="showTags"
        part-of="inbox"
      />
      <inbox-remark-card
        v-else-if="isRemarkType"
        v-bind="communicationItem"
        :show-tags="showTags"
      />
      <inbox-check-card
        v-else
        v-bind="communicationItem"
        :allow-any-user="allowAnyUser"
        :check-list-title="checkListTitle"
        :check-list-url="checkListUrl"
      />
    </template>

    <template v-else>
      <div class="sf-empty-state">
        <img
          class="sf-empty-state-image"
          :src="$imagesRequire('empty_states/communication.svg')"
        />
        <div class="sf-empty-state-text sf-c-text">
          {{ I18n.t('inbox.empty_state.select_notification') }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import InboxRemarkCard from './inbox-remark-card.vue'
import InboxCheckCard from './inbox-check-card.vue'
import RemarkV2 from '@app/shared/vue/components/molecules/remark-v2/remark-v2.vue'

export default {
  props: {
    communicationItem: {
      type: Object,
    },
    type: {
      type: String,
      required: false,
    },
    showTags: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  setup() {
    return {
      supportsCommunicationsRework:
        Silverfin.currentFirmFeatures.supports_communications_rework,
    }
  },

  computed: {
    ...mapState({
      checkLists: (state) => state.checks.checkLists,
    }),
    ...mapGetters(['loadingCommunicationItem']),
    isRemarkType() {
      return (this.type || this.communicationItem.type) === 'Remark'
    },
    isCheckListType() {
      return (this.type || this.communicationItem.type) === 'CheckList'
    },
    allowAnyUser() {
      if (this.isCheckListType) {
        return this.checkLists[this.communicationItem.ledgerId][
          this.communicationItem.checkListId
        ].allowAnyUser
      }

      return false
    },
    checkListTitle() {
      if (this.isCheckListType) {
        return this.checkLists[this.communicationItem.ledgerId][
          this.communicationItem.checkListId
        ].text
      }

      return ''
    },
    checkListUrl() {
      if (this.isCheckListType) {
        return this.checkLists[this.communicationItem.ledgerId][
          this.communicationItem.checkListId
        ].url
      }

      return ''
    },
  },

  components: {
    InboxCheckCard,
    InboxRemarkCard,
    RemarkV2,
  },
}
</script>

<style scoped>
.sf-inbox-messages-content {
  overflow: scroll;
}

.sf-inbox-messages-content > .sf-commcard {
  border: 0;
}
</style>
